import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import '@druidsoft/theme/assets/fonts/fonts-satoshi.css';
import './styles/druid-theme.scss';
import 'office-ui-fabric-core/dist/css/fabric.min.css';
import 'prismjs/themes/prism.css'
import 'jsoneditor-react/es/editor.min.css';

import { createAppStore } from './packages/Redux/appStore';
import { Provider } from 'react-redux';
import { EditorTab, SnippetExperience } from './packages/utilities/types';
import { tabState } from './packages/Redux/reduxState';

export interface AvatarOption {
  id: string;
  name: string;
  previewUrl: string;
}

export let initialOptions: any = null;
export const init = (props: {botId: string, baseUrl: string, botName: string, documentationUrl: string, selectedTab?: 'general' | 'chat' | 'voice' | 'avatar', onSuccess: () => any, onClose: () => any, onSave: (json: any) => any, onConfigureSip?: () => any, getAvatarList?: () => Promise<AvatarOption[]>}) => {
  initialOptions = props;
  const rootElem = document.getElementById('webchateditor-root');
  if(rootElem) {
    ReactDOM.unmountComponentAtNode(rootElem);
  }

  const store = createAppStore(props.selectedTab ? tabState(props.selectedTab as EditorTab, SnippetExperience.Chat) : {});
  ReactDOM.render(
    <Provider store={store} key={props.botId}>
      <App {...props}/>
    </Provider>,
    document.getElementById('webchateditor-root')
  );
}
export const reInitialize = () => {
  init(initialOptions);
}


